import React from 'react';
import { GamesIcons } from 'assets';
import { ModuleName } from './LobbyGame.config';
import { ContainerExternal, GameIcon, GameTitle } from './LobbyGame.styles';

interface ILobbyExternalGame {
  href: string;
  title: string;
  iconName: ModuleName;
  backgroundName?: ModuleName;
}

export const LobbyExternalGame: React.FC<ILobbyExternalGame> = ({
  href,
  title,
  iconName,
  backgroundName = iconName,
}) => {
  const params = window.innerHeight > 375 ? 60 : 40;

  return (
    <ContainerExternal
      gamename={backgroundName}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      <GameIcon>{GamesIcons[iconName]?.(params, params)}</GameIcon>
      <GameTitle>{title}</GameTitle>
    </ContainerExternal>
  );
};
